// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6795":"0e947300","9242":"6bc69632"}[chunkId] + ".chunk.css";
};